import { useState, useEffect } from 'react';
import { CompositeDecorator, EditorState } from 'draft-js';
import { findLinkEntities } from 'components/create/editor/find-link-entities';
import Link from 'components/create/editor/link';
import { serializeHtmlToDraftJs, serializeDraftJsToHtml } from 'lib/draft-js-serializer.js';

export const useDraftJsEditorState = ({ text }) => {
  const [firstRender, setFirstRender] = useState(false);
  const [editorState, setEditorState] = useState(EditorState.createEmpty(compositeDecorator));

  useEffect(() => {
    if (text && !firstRender) {
      const contentState = serializeHtmlToDraftJs(text);
      setEditorState(EditorState.createWithContent(contentState));
    }
  }, [text, firstRender]);

  function getMarkupFromEditorState(editor) {
    if (!firstRender) {
      // for some reason, the <Editor /> component in DraftJS has its onChange prop
      //  called on first render. track+suppress any effects by setting this variable
      setFirstRender(true);
      return serializeDraftJsToHtml(editorState);
    }

    const newState = EditorState.set(editor, { decorator: compositeDecorator });
    setEditorState(newState);
    return serializeDraftJsToHtml(newState);
  }

  return [editorState, getMarkupFromEditorState];
};

// private
const compositeDecorator = new CompositeDecorator([
  {
    strategy: findLinkEntities,
    component: Link,
  },
]);
